// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"YgfWT","rc-tabs-tab-active":"_89e24","input-suffix":"AzCUr","nav-item":"_4uCAV","nav-container":"mqR4J","nav-list":"h3QKH"};